import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["aria-expanded"];
import { computed, ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExpandableText',
    props: {
        text: { default: "" },
        fallback: { default: "Sin descripcion disponible." },
        seeMoreLabel: { default: "Ver mas" },
        seeLessLabel: { default: "Ver menos" }
    },
    setup(__props) {
        const props = __props;
        const isExpanded = ref(false);
        const normalizedText = computed(() => props.text?.trim() || props.fallback);
        const canToggle = computed(() => normalizedText.value.length > 140);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("p", {
                    class: _normalizeClass(["text-sm text-eblack-600", { 'line-clamp-3': !isExpanded.value }])
                }, _toDisplayString(normalizedText.value), 3),
                (canToggle.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "mt-1 text-sm font-medium text-eorange-600 hover:text-eorange-700",
                        "aria-expanded": String(isExpanded.value),
                        onClick: _cache[0] || (_cache[0] = ($event) => (isExpanded.value = !isExpanded.value))
                    }, _toDisplayString(isExpanded.value ? __props.seeLessLabel : __props.seeMoreLabel), 9, _hoisted_1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
